import { defineMessages } from 'react-intl';

export default defineMessages({
  'edit_form_save_label': {
    'id': 'edit_form.edit_form_save_label',
    'defaultMessage': 'Save',
    'description': 'Edit form save button text'
  },
  'edit_form_cancel_label': {
    'id': 'edit_form.edit_form_cancel_label',
    'defaultMessage': 'Cancel',
    'description': 'Edit form cancel button text'
  },
});



// WEBPACK FOOTER //
// ./src/client/components/forms/messages.js